<template>
  <v-flex
    layout
    row
    align-center
    :class="[gameType === 'scrapPicture' ? 'scrapPictureClass' : null]"
  >
  <v-flex layout column justify-center style="margin-left: 5em;">
    <v-flex layout row justify-center>
      <v-radio-group v-model="coverType" row>
        <v-radio :label="$t('gameScrapPicture.radioLabel.coverColor')" value="color" color="primary"></v-radio>
        <v-radio :label="$t('gameScrapPicture.radioLabel.coverPicture')" value="picture" color="primary"></v-radio>
      </v-radio-group>
    </v-flex>
    <v-flex layout row align-top style="margin-bottom: 30px">
      
      <color-picker
        v-if="coverType==='color'"
        :colorScrap="coverColor"
        :palette="paletteGroundColors"
        @changeColor="updateCoverColor"
      />

      <image-input
        v-if="coverType==='picture'"
        class="imageClass"
        :label="$t('gameScrapPicture.pictureLabel.coverPicture')"
        :default="parameters.coverPicture"
        :showImageInfos="false"
        :langEdition="langEdition"
        @change-image-input="updateCoverPicture"
      ></image-input>

      <image-input
        style="margin-left: 50px;"
        class="imageClass"
        :label="$t('gameScrapPicture.pictureLabel.backgroundPicture')"
        :default="parameters.pictureToDiscover"
        :showImageInfos="false"
        :langEdition="langEdition"
        @change-image-input="updatePictureToDiscover"
      ></image-input>

    </v-flex>
  </v-flex>
</v-flex>
</template>

<script>
import ImageInput from './ImageInput';
import ColorPicker from './ColorPicker.vue';

export default {
  name: 'GameScrapPicture',
  components: {
    ImageInput,
    //LanguageTranslator,
    ColorPicker,
  },
  props: {
    ColorPickergameId: {
      type: String,
      default: null,
    },
    gameType: {
      type: String,
      default: null,
    },
    parameters: {
      type: Object,
      default: null,
    },
    langEdition: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      //answerImage:{url:'', author:'',legend:{fr:'',en:''}},
      coverColor: '',
      coverType:'color',
      imageWidth: 200,
      imageHeight: 200,
      paletteGroundColors: [
        '#C2B280',
        '#909ba3',
        '#6b5428',
        '#76552b',
        '#402905',
      ],
      timeout: null,
    }
  },
  watch: {
    gameType(newValue) {
      return newValue;
    },
    coverType() {
      this.$emit('update-cover-type', this.coverType);
    }
  },
  created() {
    this.coverType = this.parameters.coverType

    if (this.parameters.coverColorHex) {
      this.coverColor = this.parameters.coverColorHex;
    }
  },
  methods: {
    onImageError(error) {
      console.log('imageError', error.message);
    },
    updateCoverColor(color) {
      if (typeof this.timeout === 'number') {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.coverColor = color;
        this.$emit('update-cover-color', this.coverColor);
      }, 3000);
    },
    updatePictureToDiscover(newImage) {
      delete newImage.dataUrl;
      //this.answerImage = newImage;
      //this.parameters.pictureToDiscover = newImage;
      this.$emit('update-answer-image', newImage);
    },
    updateCoverPicture(newImage) {
      delete newImage.dataUrl;
      console.log('update COVER PIC 1', newImage)
      
      //this.answerImage = newImage;
      //this.parameters.coverPicture = newImage;
      this.$emit('update-cover-picture', newImage);
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="sass" scoped>
div.v-input
 width: 300px

.deleteIcon
  max-width: 20px;
  margin-left: 7px;
  margin-right: 10px;

.onlyCheckBox
  max-width: 20px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.checkBoxWithDelete
  max-width: 20px
  max-height: 24px
  margin-left: 5px
  margin-right: 10px
  margin-top: 0px

.surveyClass
  margin-right: 30px
  max-height: 66px
  justify: left

.surveyClassWithDelete
  margin-left: 35px
  max-height: 66px

.closeSurvey
  position: absolute

.mcqClass
  margin-top: 0px
  max-height: 66px

.imageClass
  margin-top: 0px
  margin-bottom: 20px

.readOnlyClass
  pointer-events: none;

.showHintClass
  margin-bottom: 20px;
</style>
